var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronDownGray7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51607 7.05806C3.76014 6.81398 4.15587 6.81398 4.39995 7.05806L9.99967 12.6578L15.5994 7.05806C15.8435 6.81398 16.2392 6.81398 16.4833 7.05806C16.7274 7.30214 16.7274 7.69786 16.4833 7.94194L10.4416 13.9836C10.1975 14.2277 9.80181 14.2277 9.55773 13.9836L3.51607 7.94194C3.27199 7.69786 3.27199 7.30214 3.51607 7.05806Z",
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownGray7);
export default __webpack_public_path__ + "static/media/icon-chevron-down-gray7.045ca17cbd159474781ffb958c817f04.svg";
export { ForwardRef as ReactComponent };